import { RequestDemo } from './RequestDemo'

const Buttons = { RequestDemo }

export { Buttons as default }
